import { StyleSheet } from 'react-native';
export const styles = StyleSheet.create({
    overlay: {
        flex: 1,
        backgroundColor: 'rgba(0,0,0,0.3)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    dialog: {
        width: 280,
        backgroundColor: '#fff',
        borderRadius: 12,
        padding: 24,
        alignItems: 'center',
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 12,
        color: '#222',
    },
    message: {
        fontSize: 16,
        color: '#444',
        marginBottom: 20,
        textAlign: 'center',
    },
    buttonRow: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignSelf: 'stretch',
    },
    button: {
        paddingHorizontal: 16,
        paddingVertical: 8,
    },
    confirmText: {
        color: '#1677ff',
        fontSize: 16,
        fontWeight: 'bold',
    },
    cancelText: {
        color: '#888',
        fontSize: 16,
        marginRight: 8,
    },
});
